module.exports = __webpack_public_path__ + "img/bezier.7a60c665.svg";